<!-- 个人电站列表 -->
<template>
  <component :is="currentComponent" v-if="currentComponent" />
</template>

<script setup>
import { computed } from 'vue'
import Engineering from './list-engineering.vue'
import Customer from './list-customer.vue'
import { checkRole } from '@/utils/permission.js'

/**
 * 按角色自动决定展示组件（不再提供切换按钮）：
 * - jd-develop / jd-project → 「我创建的电站」（Engineering）
 * - jd-support             → 「待审批的电站 / 我审批的电站」（Customer）
 * jd-support 与 jd-develop/jd-project 同时命中时，工程类优先。
 */
const currentComponent = computed(() => {
  if (checkRole(['jd-develop', 'jd-project'])) return Engineering
  if (checkRole(['jd-support'])) return Customer
  return null
})
</script>
